<script setup lang="ts">
import EmblaCarousel from '@/shared/ui/EmblaCarousel/index';
import LawyerCard from '@/widgets/LawyerCard/index';
import AppIcon from '@/shared/ui/AppIcon/index';
import { useCityLawyers } from '@/pages/lawyer/composables/useCityLawyers';

const isMobile: boolean = useIsMobile();
const { lawyers, title, link, dotsCount } = useCityLawyers();
</script>

<template>
  <section v-if="lawyers.length" :class="['city-lawyers-section', { _mobile: isMobile }]">
    <h2 class="city-lawyers-section__title">
      <NuxtLink class="city-lawyers-section__link" :to="link">
        {{ title }}
        <AppIcon
          name="ArrowRightMain"
          width="8px"
          height="14px"
          class="city-lawyers-section__icon"
        />
      </NuxtLink>
    </h2>

    <EmblaCarousel
      class="city-lawyers-section__slider"
      :dots-count="dotsCount"
      :options="{
        loop: true,
        slidesToScroll: isMobile ? 1 : 2,
        align: 'start',
      }"
    >
      <div v-for="lawyer in lawyers" :key="lawyer.id" class="city-lawyers-section__slide">
        <LawyerCard :data="lawyer" is-card-slider is-push-to-feedbacks />
      </div>
    </EmblaCarousel>
  </section>
</template>

<style lang="less">
.city-lawyers-section {
  margin-top: @size-x10;

  &__title {
    font-weight: 600;
    font-size: @size-x6;
    line-height: 25px;
    color: @color-elephant;
    margin: 0 0 @size-x5;
  }

  &__link {
    display: inline-flex;
    align-items: center;
    gap: @size-x3;
    line-height: 1;
    color: @color-elephant;

    &:hover {
      color: @color-persimmon;
    }
  }

  &__icon {
    margin-top: 4px;
  }

  &__slider {
    padding: 0 72px;
  }

  &__slider .embla__container {
    padding: 20px 0 45px;
  }

  &__slide {
    box-sizing: border-box;
    flex: 0 0 50%;
    min-width: 0;
    padding: 0 20px;
  }

  &._mobile &__slider {
    padding: 0;
  }

  &._mobile &__slider .slider-arrow._prev {
    left: -16px;
  }

  &._mobile &__slider .slider-arrow._next {
    right: -16px;
  }

  &._mobile &__slider .embla__viewport {
    margin: 0 12px;
  }

  &._mobile &__slider .embla__container {
    gap: 16px;
    padding: 16px 0 39px;
  }

  &._mobile &__slide {
    flex: 0 0 100%;
    padding: 0 12px;
  }

  &._mobile &__slide .footer-profile-link {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
